module.exports = __webpack_public_path__ + "static/media/step-indicator-2of2.d91b3777.svg";